// extracted by mini-css-extract-plugin
export var banner = "_j2-0";
export var settingRow = "_j2-2";
export var titleIcon = "_j2-1";